/**
 * 异步加载js文件
 * @param {url} js文件的地址
 * @param {target} scirpt标签插入的节点，默认是body
 */
export const loadJS = (url, target) => {
    return new Promise((resolve, reject) => {
        const scriptTag = document.createElement("script");
        scriptTag.type = "text/javascript";
        // scriptTag.async = true;
        scriptTag.src = url;
        console.log('loadJS', url);
        scriptTag.onload = scriptTag.onreadystatechange = function () {
            if (
                !this.readyState ||
                this.readyState === "loaded" ||
                this.readyState === "complete"
            ) {
                resolve();
            } else {
                reject({
                    message: "javascript 文件加载失败",
                });
            }
        };
        scriptTag.onerror = function () {
            reject({
                message: "javascript 文件加载失败",
            });
        };
        if (target) {
            document.querySelector(target).appendChild(scriptTag);
        } else {
            document.body.appendChild(scriptTag);
        }
    });
};
